import styled from "styled-components";

const StyledTip = styled.div`
  position: relative;
  display: inline-flex;

  &:hover > [role="tooltip"],
  &:focus-within > [role="tooltip"] {
    opacity: 1;
    visibility: visible;
    transform: translate(var(--tooltip-translate-x, -50%), 0);
  }
`;

const StyledTooltip = styled.span`
  position: absolute;
  z-index: 30;
  left: var(--tooltip-left, 50%);
  bottom: calc(100% + clamp(6px, 1vw, 9px));
  width: max-content;
  max-width: min(
    190px,
    calc(100vw - var(--page-gutter) - var(--page-gutter) - 42px)
  );
  padding: clamp(4px, 0.67vw, 6px) clamp(6px, 0.9vw, 8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  background: #09111a;
  color: #f0ece5 !important;
  font-family: Roboto-Regular;
  font-size: clamp(9px, calc(8px + 0.33vw), 11px);
  line-height: 1.2 !important;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transform: translate(var(--tooltip-translate-x, -50%), 5px);
  transition:
    opacity 140ms ease,
    transform 140ms ease,
    visibility 140ms;

  @media (max-width: 400px) {
    max-width: 120px;
    border-radius: 6px;
  }
`;

export const Tip = ({ target, tip }) => (
  <StyledTip>
    {target}
    <StyledTooltip role="tooltip">{tip}</StyledTooltip>
  </StyledTip>
);
